// 활동(페이지 이동/요청) 기준 20분 비활동 시 만료되도록 구현
// 쿠키 2개 사용: session_token, session_last (epoch ms)

const COOKIE_OPTIONS = {
    path: '/',
    secure: true,           // HTTPS 권장
    sameSite: 'Lax',
};

const MAX_INACTIVITY_MS = 20 * 60 * 1000; // 20분

function writeCookie(name, value, { path = '/', secure = false, sameSite = 'Lax', maxAge } = {}) {
    let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=${path}` //SameSite=${sameSite}`;
    //if (secure) cookie += '; Secure';
    if (typeof maxAge === 'number') cookie += `; Max-Age=${maxAge}`;
    document.cookie = cookie;
}

function readCookie(name) {
    const parts = document.cookie?.split(';') || [];
    for (const part of parts) {
        const [k, ...rest] = part.trim().split('=');
        if (decodeURIComponent(k) === name) {
            return decodeURIComponent(rest.join('='));
        }
    }
    return null;
}

function deleteCookie(name) {
    document.cookie = `${encodeURIComponent(name)}=; Max-Age=0; path=/; SameSite=Lax`;
}

export function setSession(token) {
    // 로그인 성공 시 호출: 즉시 시작 + 마지막 활동시간 저장
    writeCookie('session_token', token, { ...COOKIE_OPTIONS, maxAge: 60 * 60 }); // 안전빵으로 1시간 절대만료(선택)
    writeCookie('session_last', String(Date.now()), { ...COOKIE_OPTIONS, maxAge: 60 * 60 });
}

export function getSessionToken() {
    return readCookie('session_token');
}

export function clearSession() {
    deleteCookie('session_token');
    deleteCookie('session_last');
}

export function isSessionExpired() {
    const last = Number(readCookie('session_last') || '0');
    if (!last) return true;
    return Date.now() - last > MAX_INACTIVITY_MS;
}

export function touchSession() {
    // 활동 발생 시 마지막 활동시간 갱신 (슬라이딩 만료)
    writeCookie('session_last', String(Date.now()), { ...COOKIE_OPTIONS, maxAge: 60 * 60 });
}
